export default __webpack_public_path__ + "static/media/search.52fdea0f.svg";